import { useEffect } from "react";
import { inject } from "mobx-react";
import { isLeft } from "fp-ts/Either";
import type { Store } from "@inferno/renderer-shared-core";
import { ILog, getPaths, AuthorPagePayloadResolver } from "@ihr-radioedit/inferno-core";
import type { Block_SitesItemBlock_Fragment, PublishRecordFragment } from "@ihr-radioedit/inferno-webapi";
import { Heading } from "../../ui";

import styles from "./AuthorContent.module.scss";
const log = ILog.logger("AuthorContent");

export type AuthorContentProps = {
  store?: Store;
  content: PublishRecordFragment;
  block: Block_SitesItemBlock_Fragment;
};

export const AuthorFrontMatter = inject("store")(({ content, block, store }: AuthorContentProps) => {
  if (!store || content === null) {
    return null;
  }

  useEffect(() => {
    store.storeBlock(block);
  });

  const resolvedPayload = AuthorPagePayloadResolver.decode(content.payload);
  if (isLeft(resolvedPayload)) {
    log.error(`Payload did not validate! ${getPaths(resolvedPayload)}`);
    return null;
  }
  const payload = resolvedPayload.right;
  const { fields } = payload;

  if (!fields) {
    return null;
  }

  const { name } = fields;

  return (
    <div className={styles.authorFrontMatter}>
      <Heading level={1}>{name.value}</Heading>
    </div>
  );
});

export default AuthorFrontMatter;
